import apiClient from "../../client/apiClient"
import { appendQueryParams } from "../../utils"

export type Group = {
  _id: string
  name: string
  system: { _id: string; name: string; code?: string } | string
  classes: ({ _id: string; name: string; order?: number } | string)[]
  status: "active" | "inactive"
  createdAt?: string
}

const BASE = "/group"

export const listGroups = async (params?: { system?: string; class?: string; status?: string }) => {
  const res = await apiClient({ method: "GET", url: appendQueryParams(BASE, params || {}) })
  return res.data
}

export const getGroupById = async (id: string) => {
  const res = await apiClient({ method: "GET", url: `${BASE}/${id}` })
  return res.data
}

export const createGroup = async (data: { name: string; system: string; classes: string[] }) => {
  const res = await apiClient({ method: "POST", url: BASE, data })
  return res.data
}

export const updateGroup = async (
  id: string,
  data: { name?: string; system?: string; classes?: string[]; status?: "active" | "inactive" }
) => {
  const res = await apiClient({ method: "PUT", url: `${BASE}/${id}`, data })
  return res.data
}

export const deleteGroup = async (id: string) => {
  const res = await apiClient({ method: "DELETE", url: `${BASE}/${id}` })
  return res.data
}
